import { useCallback, useEffect, useRef } from "react";

import { IStaffJob } from "@/api";
import { useUnitStaffJobs } from "@/common/AppConfigUtils";

import { StaffJobPicker as StaffJobPickerComponent } from "../../StaffJobPicker";
import { TShiftEditorProps } from "../types";

export const StaffJobPicker = (props: TShiftEditorProps) => {
  const { staffShift, updateStaffShift, unitOfShift, readonly, staffDetails } = props;

  const staffPrimaryJobId = staffDetails.principalStaffJobId;
  const staffPrimaryJobThroughTypeId = useUnitStaffJobs(unitOfShift.id)?.find(
    (job) => job.staffTypeKey === staffDetails.staffTypeKey,
  )?.id;
  const computedUserPrimaryJobId = staffPrimaryJobId || staffPrimaryJobThroughTypeId;

  const updateStaffJobId = useCallback(
    (value: IStaffJob["id"] | undefined) => {
      if (!value) return;

      updateStaffShift({
        ...staffShift,
        staffJobId: value,
      });
    },
    [staffShift, updateStaffShift],
  );

  // Auto assign job on shift load
  const autoAssigned = useRef(false);
  useEffect(() => {
    if (!staffShift.staffJobId && computedUserPrimaryJobId && !autoAssigned.current) {
      updateStaffJobId(computedUserPrimaryJobId);
      autoAssigned.current = true;
    }
  }, [computedUserPrimaryJobId, updateStaffJobId, staffShift.staffJobId]);
  useEffect(() => {
    autoAssigned.current = false;
  }, [staffShift.id]);

  return (
    <StaffJobPickerComponent
      label="Assigned Job"
      size="small"
      readOnly={readonly}
      multiple={false}
      value={staffShift.staffJobId}
      unitId={unitOfShift.id}
      onChange={updateStaffJobId}
    />
  );
};
